module.exports = __webpack_public_path__ + "static/cyric-symbol-SCAG-ace42d662874e820f0ee955dbff3c2b1.png";